export const rolesAdmin = ["ADMIN"];
export const rolesManager = [...rolesAdmin, "GESTOR"];
export const rolesUser = [...rolesManager, "USUARIO", "VENDEDOR"];

export function hasAuthorization(user: any, roles?: string[]) {
  return !roles || roles.includes(user.papel);
}
